import React, {Component} from 'react';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {Card, Table, Loader, Popup, Button, Dimmer} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import RejectModal from './modal/reject';
import GlobalChecker from './globalChecker';
import Checker from './checker';
import OnOrdersModal from '../stock/onOrderModal';
import TransportSelector from './transportSelector';

class DataTable extends Component {
  openOnOrderModal(partCode) {
    this.props.showOrderPartOnOrder(partCode);
  }

  showAdditionalInfo(index, event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelectItem(index);
  }

  onCreateClick(partCode) {
    this.props.changePartsFormValue('incomingPart', partCode);
    if (window.location) {
      window.open(`${window.location.origin}/maestro-repuestos`, '_blank');
    }
  }

  renderLoader() {
    const {rejectingOrder, generatingTxt} = this.props;
    if (!(rejectingOrder || generatingTxt)) {
      return null;
    }

    return (
      <Dimmer active inverted>
        <Loader
          inverted
          inline='centered'
          content={rejectingOrder ? 'Negando Pedido' : 'Generando TXT'}
        />
      </Dimmer>
    );
  }

  renderLoaderOrOrders() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation() {
    const {providersOrdersList, rejectingOrder, generatingTxt, provider} =
      this.props;

    if (!providersOrdersList.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={17}>
            No hay datos con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return providersOrdersList.map((order, index) => {
      return (
        <Table.Row
          textAlign='center'
          key={index}
          className={`${order.salesICC ? '' : 'new-item'} `}
        >
          <Table.Cell className='availability'>
            <Popup
              inverted
              trigger={<span>{order.rejectionCode}</span>}
              on='hover'
            >
              <div>{order.rejectionDescription}</div>
            </Popup>
          </Table.Cell>
          <Table.Cell className='provider'>{order.providerName}</Table.Cell>
          <Table.Cell>{order.orderCode}</Table.Cell>
          <Table.Cell>{order.agency}</Table.Cell>
          <Table.Cell className='user'>{order.user}</Table.Cell>
          <Table.Cell
            className='part-code'
            onMouseEnter={this.showAdditionalInfo.bind(this, index)}
          >
            {order.partCode}
          </Table.Cell>
          <Table.Cell className='description'>{order.name}</Table.Cell>
          <Table.Cell>{order.salesICC}</Table.Cell>
          <Table.Cell textAlign='right'>{order.oh}</Table.Cell>
          <Table.Cell
            textAlign='right'
            className='on-order'
            onClick={this.openOnOrderModal.bind(this, order.partCode)}
          >
            {order.oo}
          </Table.Cell>
          <Table.Cell textAlign='right'>{order.scc}</Table.Cell>
          <Table.Cell textAlign='right'>
            {getNumericValue(order.fob, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
          <Table.Cell textAlign='right' className='total-fob'>
            {getNumericValue(order.totalFob, 2)}
          </Table.Cell>
          <Table.Cell>
            <Checker
              checked={order.checked}
              index={index}
              disabled={!order.salesICC || !provider || provider === 'all'}
              transport={order.transport}
            />
          </Table.Cell>
          <Table.Cell className='transport' textAlign='left'>
            <TransportSelector index={index} value={order.transport} />
          </Table.Cell>
          <Table.Cell className='status'>{order.status || '-'}</Table.Cell>
          <Table.Cell className='specials'>
            {order.specialDescription}
          </Table.Cell>
          <Table.Cell className='actions'>
            <RejectModal
              index={index}
              dealer={order.dealer}
              orderSequence={order.orderSequence}
              disabled={rejectingOrder || generatingTxt}
            />
            {this.renderCreateAction(order.salesICC, order.partCode)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderCreateAction(icc, partCode) {
    if (icc) {
      return null;
    }
    return (
      <Button
        secondary
        size='mini'
        disabled={false}
        onClick={() => this.onCreateClick(partCode)}
      >
        Crear
      </Button>
    );
  }

  render() {
    const {showDetails, provider} = this.props;

    return (
      <Card raised fluid>
        {this.renderLoader()}

        <Table
          striped
          className={`scrollable-body ${showDetails ? 'half-height' : ''}`}
        >
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='availability'>
                Disp.
              </Table.HeaderCell>
              <Table.HeaderCell className='provider'>
                Proveedor
              </Table.HeaderCell>
              <Table.HeaderCell>N.Pedido</Table.HeaderCell>
              <Table.HeaderCell>Agencia</Table.HeaderCell>
              <Table.HeaderCell className='user'>Usuario</Table.HeaderCell>
              <Table.HeaderCell className='part-code'>Código</Table.HeaderCell>
              <Table.HeaderCell className='description'>
                Descripcion
              </Table.HeaderCell>
              <Table.HeaderCell>ICC</Table.HeaderCell>
              <Table.HeaderCell>OH</Table.HeaderCell>
              <Table.HeaderCell>OO</Table.HeaderCell>
              <Table.HeaderCell>SCC</Table.HeaderCell>
              <Table.HeaderCell>FOB</Table.HeaderCell>
              <Table.HeaderCell>Cant.</Table.HeaderCell>
              <Table.HeaderCell className='total-fob'>
                Total Fob
              </Table.HeaderCell>
              <Table.HeaderCell>
                <GlobalChecker disabled={!provider || provider === 'all'} />
              </Table.HeaderCell>
              <Table.HeaderCell className='transport'>Vía</Table.HeaderCell>
              <Table.HeaderCell className='status'>Estado</Table.HeaderCell>
              <Table.HeaderCell className='specials'>
                Especiales
              </Table.HeaderCell>
              <Table.HeaderCell className='actions'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderLoaderOrOrders()}</Table.Body>
        </Table>
        <OnOrdersModal />
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.providerOrdersList.loading,
    'providersOrdersList': state.providerOrdersList.list,
    'rejectingOrder': state.providerOrdersList.rejecting,
    'generatingTxt': state.providerOrdersList.generatingTxt,
    'location': ownProps.location,
  };
};

const {
  navigateTo,
  changePartsFormValue,
  showOrderPartOnOrder,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  changePartsFormValue,
  showOrderPartOnOrder,
})(DataTable);
